import {createMuiTheme} from "@material-ui/core";

export const Theme = createMuiTheme({
    palette: {
        primary: {
            light: '#382135',
            main: '#281125',
            dark: '#180115',
            contrastText: '#FDFDFD',
        },
        secondary: {
            light: '#6A9BD5',
            main: '#3A6BA5',
            dark: '#0E376F',
            contrastText: '#FDFDFD',
        },
        error: {
            main: '#F9D401',
        }
    },
});

//bg:#D8F2DA

//.dark-primary-color    { background: #512DA8; }
//.default-primary-color { background: #673AB7; }
//.light-primary-color   { background: #D1C4E9; }
//.text-primary-color    { color: #FFFFFF; }
//.accent-color          { background: #FFC107; }
//.primary-text-color    { color: #212121; }
//.secondary-text-color  { color: #757575; }
//.divider-color         { border-color: #BDBDBD; }
